import React from "react";
import { compact } from "LIB/arrays";

export function fobFormat(address) {
  return address
    ? [address.city, address.state, address.country].join("-")
    : "";
}

export function addressFormat(address) {
  return address
    ? compact([
        address.company_name,
        address.care_of,
        address.line1,
        address.line2,
        `${address.city || ""}, ${address.state || ""} ${address.postal_code ||
          ""}`,
        address.country
      ]).map((a, idx) => (
        <span key={idx}>
          {a}
          <br />
        </span>
      ))
    : "";
}

export function addressFormatDropDown(address) {
  return address
    ? compact([
        address.company_name,
        address.care_of,
        address.line1,
        address.line2,
        `${address.city || ""}, ${address.state || ""} ${address.postal_code ||
          ""}`,
        address.country
      ]).join(" ")
    : "";
}



// WEBPACK FOOTER //
// ./app/lib/formatters/address.jsx